import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import { or } from 'ember-truth-helpers';

interface RouteChangePlaceholderSignature {
  Args: {
    pageName: string;
    newLocation: string;
    newRoute: string;
    newQuery?: Record<string, unknown>;
  };
  Element: HTMLDivElement;
}

<template>
  <div class="h-full w-full flex flex-col items-center justify-center align-middle" data-test-route-change-placeholder>
    <img src="/assets/images/empty-state/no-notifications.svg" alt="We've moved" class="w-80 h-80 mb-4" />
    <h1 class="text-carbon-80 font-semibold mb-2">Looking for {{@pageName}}?</h1>
    <p class="text-carbon-80 mb-4">We've moved it to {{@newLocation}}.</p>
    <LinkTo @route={{@newRoute}} class="btn btn--brand ml-4" @query={{or @newQuery (hash)}} data-test-new-route-link>
      Take me there
    </LinkTo>
  </div>
</template> satisfies TOC<RouteChangePlaceholderSignature>;
